@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-25_629_350)
public val Res.string.daily_records_title: StringResource by lazy {
      StringResource("string:daily_records_title", "daily_records_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101404, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142228, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90739, 47),
      ))
    }

@delegate:ResourceContentHash(-1_306_035_512)
public val Res.string.daily_records_unlock: StringResource by lazy {
      StringResource("string:daily_records_unlock", "daily_records_unlock", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101452, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142304, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90787, 44),
      ))
    }

@delegate:ResourceContentHash(-1_003_191_427)
public val Res.string.daily_result_saved: StringResource by lazy {
      StringResource("string:daily_result_saved", "daily_result_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101513, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142381, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90832, 46),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.daily_rows_day: StringResource by lazy {
      StringResource("string:daily_rows_day", "daily_rows_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101560, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142452, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90879, 26),
      ))
    }

@delegate:ResourceContentHash(1_109_315_587)
public val Res.string.daily_rows_labour: StringResource by lazy {
      StringResource("string:daily_rows_labour", "daily_rows_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101591, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142487, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90906, 37),
      ))
    }

@delegate:ResourceContentHash(903_205_032)
public val Res.string.daily_rows_margin: StringResource by lazy {
      StringResource("string:daily_rows_margin", "daily_rows_margin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101633, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142533, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90944, 33),
      ))
    }

@delegate:ResourceContentHash(208_411_916)
public val Res.string.daily_rows_open_day: StringResource by lazy {
      StringResource("string:daily_rows_open_day", "daily_rows_open_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101667, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142575, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90978, 47),
      ))
    }

@delegate:ResourceContentHash(-569_839_923)
public val Res.string.daily_rows_plan: StringResource by lazy {
      StringResource("string:daily_rows_plan", "daily_rows_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101723, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142643, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91026, 115),
      ))
    }

@delegate:ResourceContentHash(-1_223_248_724)
public val Res.string.daily_rows_result: StringResource by lazy {
      StringResource("string:daily_rows_result", "daily_rows_result", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101811, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142767, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91142, 33),
      ))
    }

@delegate:ResourceContentHash(-2_051_114_157)
public val Res.string.daily_rows_takings: StringResource by lazy {
      StringResource("string:daily_rows_takings", "daily_rows_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101845, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142817, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91176, 38),
      ))
    }

@delegate:ResourceContentHash(1_707_654_922)
public val Res.string.dashboard_action_inbox: StringResource by lazy {
      StringResource("string:dashboard_action_inbox", "dashboard_action_inbox", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101880, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142860, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91215, 46),
      ))
    }

@delegate:ResourceContentHash(-1_525_762_631)
public val Res.string.dashboard_active_employees: StringResource by lazy {
      StringResource("string:dashboard_active_employees", "dashboard_active_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101931, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 142923, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91262, 62),
      ))
    }

@delegate:ResourceContentHash(1_661_045_104)
public val Res.string.dashboard_all_caught_up: StringResource by lazy {
      StringResource("string:dashboard_all_caught_up", "dashboard_all_caught_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 101998, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143014, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91325, 51),
      ))
    }

@delegate:ResourceContentHash(-1_386_010_136)
public val Res.string.dashboard_change_availability_request: StringResource by lazy {
      StringResource("string:dashboard_change_availability_request", "dashboard_change_availability_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102058, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143078, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91377, 81),
      ))
    }

@delegate:ResourceContentHash(1_958_583_685)
public val Res.string.dashboard_clock_in: StringResource by lazy {
      StringResource("string:dashboard_clock_in", "dashboard_clock_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102152, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143196, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91459, 38),
      ))
    }

@delegate:ResourceContentHash(-588_142_343)
public val Res.string.dashboard_currently_at_work: StringResource by lazy {
      StringResource("string:dashboard_currently_at_work", "dashboard_currently_at_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102276, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143352, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91575, 59),
      ))
    }

@delegate:ResourceContentHash(-692_236_993)
public val Res.string.dashboard_currently_at_work_location: StringResource by lazy {
      StringResource("string:dashboard_currently_at_work_location", "dashboard_currently_at_work_location", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102203, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143259, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91498, 76),
      ))
    }

@delegate:ResourceContentHash(-1_097_592_062)
public val Res.string.dashboard_define_patterns: StringResource by lazy {
      StringResource("string:dashboard_define_patterns", "dashboard_define_patterns", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102332, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143428, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91635, 73),
      ))
    }

@delegate:ResourceContentHash(-1_886_670_240)
public val Res.string.dashboard_engagement_ended: StringResource by lazy {
      StringResource("string:dashboard_engagement_ended", "dashboard_engagement_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102402, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143510, 258),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91709, 170),
      ))
    }

@delegate:ResourceContentHash(-596_132_424)
public val Res.string.dashboard_estimated_earnings: StringResource by lazy {
      StringResource("string:dashboard_estimated_earnings", "dashboard_estimated_earnings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102565, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143769, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91880, 64),
      ))
    }

@delegate:ResourceContentHash(824_773_271)
public val Res.string.dashboard_fill_result_target: StringResource by lazy {
      StringResource("string:dashboard_fill_result_target", "dashboard_fill_result_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102650, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143866, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 91945, 60),
      ))
    }

@delegate:ResourceContentHash(-1_068_859_348)
public val Res.string.dashboard_fill_result_title: StringResource by lazy {
      StringResource("string:dashboard_fill_result_title", "dashboard_fill_result_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102727, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 143963, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92006, 71),
      ))
    }

@delegate:ResourceContentHash(79_034_995)
public val Res.string.dashboard_fill_result_today: StringResource by lazy {
      StringResource("string:dashboard_fill_result_today", "dashboard_fill_result_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102811, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144059, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92078, 51),
      ))
    }

@delegate:ResourceContentHash(-615_628_683)
public val Res.string.dashboard_fill_result_yesterday: StringResource by lazy {
      StringResource("string:dashboard_fill_result_yesterday", "dashboard_fill_result_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102863, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144127, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92130, 59),
      ))
    }

@delegate:ResourceContentHash(1_072_880_085)
public val Res.string.dashboard_labor_cost_percent: StringResource by lazy {
      StringResource("string:dashboard_labor_cost_percent", "dashboard_labor_cost_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103023, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144347, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92282, 80),
      ))
    }

@delegate:ResourceContentHash(2_117_325_203)
public val Res.string.dashboard_labor_cost_percent_income: StringResource by lazy {
      StringResource("string:dashboard_labor_cost_percent_income", "dashboard_labor_cost_percent_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 102923, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144191, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92190, 91),
      ))
    }

@delegate:ResourceContentHash(-962_755_293)
public val Res.string.dashboard_more_employees: StringResource by lazy {
      StringResource("string:dashboard_more_employees", "dashboard_more_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103116, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144504, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92363, 48),
      ))
    }

@delegate:ResourceContentHash(17_378_759)
public val Res.string.dashboard_new_roster: StringResource by lazy {
      StringResource("string:dashboard_new_roster", "dashboard_new_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103169, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144553, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92412, 44),
      ))
    }

@delegate:ResourceContentHash(-992_855_559)
public val Res.string.dashboard_next_shift: StringResource by lazy {
      StringResource("string:dashboard_next_shift", "dashboard_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103214, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144614, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92457, 44),
      ))
    }

@delegate:ResourceContentHash(-1_100_228_962)
public val Res.string.dashboard_no_active_data: StringResource by lazy {
      StringResource("string:dashboard_no_active_data", "dashboard_no_active_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103267, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144679, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92502, 52),
      ))
    }

@delegate:ResourceContentHash(-588_670_649)
public val Res.string.dashboard_no_issues: StringResource by lazy {
      StringResource("string:dashboard_no_issues", "dashboard_no_issues", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103316, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144740, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92555, 51),
      ))
    }

@delegate:ResourceContentHash(-1_299_649_081)
public val Res.string.dashboard_no_messages: StringResource by lazy {
      StringResource("string:dashboard_no_messages", "dashboard_no_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103376, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144816, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92607, 49),
      ))
    }

@delegate:ResourceContentHash(-1_762_606_634)
public val Res.string.dashboard_no_one_scheduled: StringResource by lazy {
      StringResource("string:dashboard_no_one_scheduled", "dashboard_no_one_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103438, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144906, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92657, 62),
      ))
    }

@delegate:ResourceContentHash(-1_766_042_689)
public val Res.string.dashboard_no_one_working: StringResource by lazy {
      StringResource("string:dashboard_no_one_working", "dashboard_no_one_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103509, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 144993, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92720, 72),
      ))
    }

@delegate:ResourceContentHash(248_603_366)
public val Res.string.dashboard_no_rosters: StringResource by lazy {
      StringResource("string:dashboard_no_rosters", "dashboard_no_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103574, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145082, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92793, 84),
      ))
    }

@delegate:ResourceContentHash(-1_570_341_914)
public val Res.string.dashboard_no_upcoming_shifts: StringResource by lazy {
      StringResource("string:dashboard_no_upcoming_shifts", "dashboard_no_upcoming_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103651, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145199, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92878, 60),
      ))
    }

@delegate:ResourceContentHash(-1_504_885_048)
public val Res.string.dashboard_notifications: StringResource by lazy {
      StringResource("string:dashboard_notifications", "dashboard_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103724, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145292, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92939, 51),
      ))
    }

@delegate:ResourceContentHash(-119_281_545)
public val Res.string.dashboard_open_skeleton_slots: StringResource by lazy {
      StringResource("string:dashboard_open_skeleton_slots", "dashboard_open_skeleton_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103776, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145352, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92991, 69),
      ))
    }

@delegate:ResourceContentHash(-1_802_376_888)
public val Res.string.dashboard_operational_issues: StringResource by lazy {
      StringResource("string:dashboard_operational_issues", "dashboard_operational_issues", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103850, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145438, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93061, 60),
      ))
    }

@delegate:ResourceContentHash(391_718_726)
public val Res.string.dashboard_pay_estimate_note: StringResource by lazy {
      StringResource("string:dashboard_pay_estimate_note", "dashboard_pay_estimate_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 103911, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145515, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93122, 107),
      ))
    }

@delegate:ResourceContentHash(725_930_798)
public val Res.string.dashboard_pending_review: StringResource by lazy {
      StringResource("string:dashboard_pending_review", "dashboard_pending_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104023, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145687, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93230, 68),
      ))
    }

@delegate:ResourceContentHash(190_090_635)
public val Res.string.dashboard_profile: StringResource by lazy {
      StringResource("string:dashboard_profile", "dashboard_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104084, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145760, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93299, 37),
      ))
    }

@delegate:ResourceContentHash(-1_325_406_499)
public val Res.string.dashboard_recent_rosters: StringResource by lazy {
      StringResource("string:dashboard_recent_rosters", "dashboard_recent_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104118, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145806, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93337, 52),
      ))
    }

@delegate:ResourceContentHash(-1_882_981_548)
public val Res.string.dashboard_request_availability: StringResource by lazy {
      StringResource("string:dashboard_request_availability", "dashboard_request_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104175, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145879, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93390, 66),
      ))
    }

@delegate:ResourceContentHash(-1_138_821_098)
public val Res.string.dashboard_revenue_vs_labor: StringResource by lazy {
      StringResource("string:dashboard_revenue_vs_labor", "dashboard_revenue_vs_labor", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104250, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 145970, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93457, 74),
      ))
    }

@delegate:ResourceContentHash(-153_165_376)
public val Res.string.dashboard_roster_blueprints: StringResource by lazy {
      StringResource("string:dashboard_roster_blueprints", "dashboard_roster_blueprints", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104333, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146101, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93532, 59),
      ))
    }

@delegate:ResourceContentHash(-671_639_530)
public val Res.string.dashboard_select_workplace: StringResource by lazy {
      StringResource("string:dashboard_select_workplace", "dashboard_select_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104393, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146177, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93592, 58),
      ))
    }

@delegate:ResourceContentHash(1_453_647_497)
public val Res.string.dashboard_staff_checks: StringResource by lazy {
      StringResource("string:dashboard_staff_checks", "dashboard_staff_checks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104448, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146248, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93651, 58),
      ))
    }

@delegate:ResourceContentHash(887_541_743)
public val Res.string.dashboard_staff_expired: StringResource by lazy {
      StringResource("string:dashboard_staff_expired", "dashboard_staff_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104499, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146327, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93710, 51),
      ))
    }

@delegate:ResourceContentHash(-2_081_627_763)
public val Res.string.dashboard_staff_expiring: StringResource by lazy {
      StringResource("string:dashboard_staff_expiring", "dashboard_staff_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104551, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146399, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93762, 72),
      ))
    }

@delegate:ResourceContentHash(1_458_212_503)
public val Res.string.dashboard_staff_role: StringResource by lazy {
      StringResource("string:dashboard_staff_role", "dashboard_staff_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104628, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146500, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93835, 36),
      ))
    }

@delegate:ResourceContentHash(-442_461_381)
public val Res.string.dashboard_switch: StringResource by lazy {
      StringResource("string:dashboard_switch", "dashboard_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104669, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146553, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93872, 32),
      ))
    }

@delegate:ResourceContentHash(676_114_509)
public val Res.string.dashboard_take_home: StringResource by lazy {
      StringResource("string:dashboard_take_home", "dashboard_take_home", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104710, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146598, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93905, 59),
      ))
    }

@delegate:ResourceContentHash(-73_705_460)
public val Res.string.dashboard_team_schedule: StringResource by lazy {
      StringResource("string:dashboard_team_schedule", "dashboard_team_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104770, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146674, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93965, 51),
      ))
    }

@delegate:ResourceContentHash(517_043_591)
public val Res.string.dashboard_today: StringResource by lazy {
      StringResource("string:dashboard_today", "dashboard_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104822, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146742, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94017, 31),
      ))
    }

@delegate:ResourceContentHash(1_695_950_203)
public val Res.string.dashboard_tomorrow: StringResource by lazy {
      StringResource("string:dashboard_tomorrow", "dashboard_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104854, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146790, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94049, 38),
      ))
    }

@delegate:ResourceContentHash(1_536_476_630)
public val Res.string.dashboard_was_working_today: StringResource by lazy {
      StringResource("string:dashboard_was_working_today", "dashboard_was_working_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104889, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146833, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94088, 59),
      ))
    }

@delegate:ResourceContentHash(1_517_621_837)
public val Res.string.dashboard_weekly_skeleton: StringResource by lazy {
      StringResource("string:dashboard_weekly_skeleton", "dashboard_weekly_skeleton", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 104945, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146917, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94148, 53),
      ))
    }

@delegate:ResourceContentHash(-1_510_061_124)
public val Res.string.dashboard_working_next: StringResource by lazy {
      StringResource("string:dashboard_working_next", "dashboard_working_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105003, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 146983, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94202, 46),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.dashboard_workplace_fallback: StringResource by lazy {
      StringResource("string:dashboard_workplace_fallback", "dashboard_workplace_fallback", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105058, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147062, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94249, 48),
      ))
    }

@delegate:ResourceContentHash(-1_405_331_164)
public val Res.string.dashboard_workplace_switch: StringResource by lazy {
      StringResource("string:dashboard_workplace_switch", "dashboard_workplace_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105103, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147115, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94298, 58),
      ))
    }

@delegate:ResourceContentHash(879_716_839)
public val Res.string.date: StringResource by lazy {
      StringResource("string:date", "date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105560, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147696, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94731, 20),
      ))
    }

@delegate:ResourceContentHash(-4_729_974)
public val Res.string.date_day_month: StringResource by lazy {
      StringResource("string:date_day_month", "date_day_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105154, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147186, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94357, 42),
      ))
    }

@delegate:ResourceContentHash(-461_770_378)
public val Res.string.date_end_before_start: StringResource by lazy {
      StringResource("string:date_end_before_start", "date_end_before_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105197, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147229, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94400, 77),
      ))
    }

@delegate:ResourceContentHash(-1_131_315_021)
public val Res.string.date_field_placeholder: StringResource by lazy {
      StringResource("string:date_field_placeholder", "date_field_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105283, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147351, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94478, 46),
      ))
    }

@delegate:ResourceContentHash(-91_183_768)
public val Res.string.date_format_invalid: StringResource by lazy {
      StringResource("string:date_format_invalid", "date_format_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105330, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147406, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94525, 95),
      ))
    }

@delegate:ResourceContentHash(-1_622_638_041)
public val Res.string.date_outside_month: StringResource by lazy {
      StringResource("string:date_outside_month", "date_outside_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105438, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147534, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94621, 54),
      ))
    }

@delegate:ResourceContentHash(-492_409_093)
public val Res.string.date_pick_open: StringResource by lazy {
      StringResource("string:date_pick_open", "date_pick_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105509, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147625, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94676, 54),
      ))
    }

@delegate:ResourceContentHash(-1_324_212_939)
public val Res.string.day_closed: StringResource by lazy {
      StringResource("string:day_closed", "day_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105780, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147964, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94931, 26),
      ))
    }

@delegate:ResourceContentHash(-1_442_912_660)
public val Res.string.day_closed_holiday: StringResource by lazy {
      StringResource("string:day_closed_holiday", "day_closed_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105581, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147721, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94752, 58),
      ))
    }

@delegate:ResourceContentHash(-1_687_763_988)
public val Res.string.day_closed_non_trading_sunday: StringResource by lazy {
      StringResource("string:day_closed_non_trading_sunday", "day_closed_non_trading_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105636, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147788, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94811, 73),
      ))
    }

@delegate:ResourceContentHash(-490_444_527)
public val Res.string.day_closed_sunday: StringResource by lazy {
      StringResource("string:day_closed_sunday", "day_closed_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105722, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 147894, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94885, 45),
      ))
    }

@delegate:ResourceContentHash(-1_320_653_596)
public val Res.string.day_fri_short: StringResource by lazy {
      StringResource("string:day_fri_short", "day_fri_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105815, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148007, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94958, 25),
      ))
    }

@delegate:ResourceContentHash(-1_918_414_304)
public val Res.string.day_friday: StringResource by lazy {
      StringResource("string:day_friday", "day_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105884, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148092, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95023, 26),
      ))
    }

@delegate:ResourceContentHash(-540_313_968)
public val Res.string.day_friday_in_sentence: StringResource by lazy {
      StringResource("string:day_friday_in_sentence", "day_friday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105841, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148037, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94984, 38),
      ))
    }

@delegate:ResourceContentHash(-1_337_835_837)
public val Res.string.day_mon_short: StringResource by lazy {
      StringResource("string:day_mon_short", "day_mon_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105915, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148135, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95050, 25),
      ))
    }

@delegate:ResourceContentHash(-680_975_206)
public val Res.string.day_monday: StringResource by lazy {
      StringResource("string:day_monday", "day_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105992, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148220, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95115, 26),
      ))
    }

@delegate:ResourceContentHash(716_994_314)
public val Res.string.day_monday_in_sentence: StringResource by lazy {
      StringResource("string:day_monday_in_sentence", "day_monday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 105941, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148165, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95076, 38),
      ))
    }

@delegate:ResourceContentHash(816_462_898)
public val Res.string.day_no_shifts: StringResource by lazy {
      StringResource("string:day_no_shifts", "day_no_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106031, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148263, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95142, 49),
      ))
    }

@delegate:ResourceContentHash(921_679_724)
public val Res.string.day_on_friday: StringResource by lazy {
      StringResource("string:day_on_friday", "day_on_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106081, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148337, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95192, 33),
      ))
    }

@delegate:ResourceContentHash(225_396_031)
public val Res.string.day_on_monday: StringResource by lazy {
      StringResource("string:day_on_monday", "day_on_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106119, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148387, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95226, 33),
      ))
    }

@delegate:ResourceContentHash(-1_053_469_363)
public val Res.string.day_on_saturday: StringResource by lazy {
      StringResource("string:day_on_saturday", "day_on_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106165, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148441, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95260, 39),
      ))
    }

@delegate:ResourceContentHash(2_027_601_004)
public val Res.string.day_on_sunday: StringResource by lazy {
      StringResource("string:day_on_sunday", "day_on_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106205, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148489, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95300, 33),
      ))
    }

@delegate:ResourceContentHash(-1_540_919_254)
public val Res.string.day_on_thursday: StringResource by lazy {
      StringResource("string:day_on_thursday", "day_on_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106247, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148535, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95334, 39),
      ))
    }

@delegate:ResourceContentHash(1_531_926_508)
public val Res.string.day_on_tuesday: StringResource by lazy {
      StringResource("string:day_on_tuesday", "day_on_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106287, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148583, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95374, 38),
      ))
    }

@delegate:ResourceContentHash(-1_598_566_096)
public val Res.string.day_on_wednesday: StringResource by lazy {
      StringResource("string:day_on_wednesday", "day_on_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106326, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148634, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95413, 40),
      ))
    }

@delegate:ResourceContentHash(1_095_679_271)
public val Res.string.day_sat_short: StringResource by lazy {
      StringResource("string:day_sat_short", "day_sat_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106367, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148683, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95454, 25),
      ))
    }

@delegate:ResourceContentHash(-1_588_103_683)
public val Res.string.day_saturday: StringResource by lazy {
      StringResource("string:day_saturday", "day_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106434, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148762, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95525, 32),
      ))
    }

@delegate:ResourceContentHash(1_398_130_657)
public val Res.string.day_saturday_in_sentence: StringResource by lazy {
      StringResource("string:day_saturday_in_sentence", "day_saturday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106393, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148713, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95480, 44),
      ))
    }

@delegate:ResourceContentHash(1_141_879_233)
public val Res.string.day_shifts_title: StringResource by lazy {
      StringResource("string:day_shifts_title", "day_shifts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106463, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148799, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95558, 32),
      ))
    }

@delegate:ResourceContentHash(-2_077_787_427)
public val Res.string.day_sun_short: StringResource by lazy {
      StringResource("string:day_sun_short", "day_sun_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106496, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148840, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95591, 25),
      ))
    }

@delegate:ResourceContentHash(-720_445_614)
public val Res.string.day_sunday: StringResource by lazy {
      StringResource("string:day_sunday", "day_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106565, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148917, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95656, 26),
      ))
    }

@delegate:ResourceContentHash(-229_400_126)
public val Res.string.day_sunday_in_sentence: StringResource by lazy {
      StringResource("string:day_sunday_in_sentence", "day_sunday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106522, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148870, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95617, 38),
      ))
    }

@delegate:ResourceContentHash(1_857_284_675)
public val Res.string.day_thu_short: StringResource by lazy {
      StringResource("string:day_thu_short", "day_thu_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106596, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148952, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95683, 25),
      ))
    }

@delegate:ResourceContentHash(487_629_159)
public val Res.string.day_thursday: StringResource by lazy {
      StringResource("string:day_thursday", "day_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106667, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149031, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95754, 32),
      ))
    }

@delegate:ResourceContentHash(-2_114_383_727)
public val Res.string.day_thursday_in_sentence: StringResource by lazy {
      StringResource("string:day_thursday_in_sentence", "day_thursday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106622, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 148982, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95709, 44),
      ))
    }

@delegate:ResourceContentHash(-1_343_532_399)
public val Res.string.day_tue_short: StringResource by lazy {
      StringResource("string:day_tue_short", "day_tue_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106700, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149068, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95787, 25),
      ))
    }

@delegate:ResourceContentHash(-631_151_180)
public val Res.string.day_tuesday: StringResource by lazy {
      StringResource("string:day_tuesday", "day_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106766, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149154, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95857, 31),
      ))
    }

@delegate:ResourceContentHash(778_613_540)
public val Res.string.day_tuesday_in_sentence: StringResource by lazy {
      StringResource("string:day_tuesday_in_sentence", "day_tuesday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106726, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149098, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95813, 43),
      ))
    }

@delegate:ResourceContentHash(-2_141_500_355)
public val Res.string.day_wed_short: StringResource by lazy {
      StringResource("string:day_wed_short", "day_wed_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106794, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149198, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95889, 25),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString12Resources(map: MutableMap<String, StringResource>) {
  map.put("daily_records_title", Res.string.daily_records_title)
  map.put("daily_records_unlock", Res.string.daily_records_unlock)
  map.put("daily_result_saved", Res.string.daily_result_saved)
  map.put("daily_rows_day", Res.string.daily_rows_day)
  map.put("daily_rows_labour", Res.string.daily_rows_labour)
  map.put("daily_rows_margin", Res.string.daily_rows_margin)
  map.put("daily_rows_open_day", Res.string.daily_rows_open_day)
  map.put("daily_rows_plan", Res.string.daily_rows_plan)
  map.put("daily_rows_result", Res.string.daily_rows_result)
  map.put("daily_rows_takings", Res.string.daily_rows_takings)
  map.put("dashboard_action_inbox", Res.string.dashboard_action_inbox)
  map.put("dashboard_active_employees", Res.string.dashboard_active_employees)
  map.put("dashboard_all_caught_up", Res.string.dashboard_all_caught_up)
  map.put("dashboard_change_availability_request", Res.string.dashboard_change_availability_request)
  map.put("dashboard_clock_in", Res.string.dashboard_clock_in)
  map.put("dashboard_currently_at_work", Res.string.dashboard_currently_at_work)
  map.put("dashboard_currently_at_work_location", Res.string.dashboard_currently_at_work_location)
  map.put("dashboard_define_patterns", Res.string.dashboard_define_patterns)
  map.put("dashboard_engagement_ended", Res.string.dashboard_engagement_ended)
  map.put("dashboard_estimated_earnings", Res.string.dashboard_estimated_earnings)
  map.put("dashboard_fill_result_target", Res.string.dashboard_fill_result_target)
  map.put("dashboard_fill_result_title", Res.string.dashboard_fill_result_title)
  map.put("dashboard_fill_result_today", Res.string.dashboard_fill_result_today)
  map.put("dashboard_fill_result_yesterday", Res.string.dashboard_fill_result_yesterday)
  map.put("dashboard_labor_cost_percent", Res.string.dashboard_labor_cost_percent)
  map.put("dashboard_labor_cost_percent_income", Res.string.dashboard_labor_cost_percent_income)
  map.put("dashboard_more_employees", Res.string.dashboard_more_employees)
  map.put("dashboard_new_roster", Res.string.dashboard_new_roster)
  map.put("dashboard_next_shift", Res.string.dashboard_next_shift)
  map.put("dashboard_no_active_data", Res.string.dashboard_no_active_data)
  map.put("dashboard_no_issues", Res.string.dashboard_no_issues)
  map.put("dashboard_no_messages", Res.string.dashboard_no_messages)
  map.put("dashboard_no_one_scheduled", Res.string.dashboard_no_one_scheduled)
  map.put("dashboard_no_one_working", Res.string.dashboard_no_one_working)
  map.put("dashboard_no_rosters", Res.string.dashboard_no_rosters)
  map.put("dashboard_no_upcoming_shifts", Res.string.dashboard_no_upcoming_shifts)
  map.put("dashboard_notifications", Res.string.dashboard_notifications)
  map.put("dashboard_open_skeleton_slots", Res.string.dashboard_open_skeleton_slots)
  map.put("dashboard_operational_issues", Res.string.dashboard_operational_issues)
  map.put("dashboard_pay_estimate_note", Res.string.dashboard_pay_estimate_note)
  map.put("dashboard_pending_review", Res.string.dashboard_pending_review)
  map.put("dashboard_profile", Res.string.dashboard_profile)
  map.put("dashboard_recent_rosters", Res.string.dashboard_recent_rosters)
  map.put("dashboard_request_availability", Res.string.dashboard_request_availability)
  map.put("dashboard_revenue_vs_labor", Res.string.dashboard_revenue_vs_labor)
  map.put("dashboard_roster_blueprints", Res.string.dashboard_roster_blueprints)
  map.put("dashboard_select_workplace", Res.string.dashboard_select_workplace)
  map.put("dashboard_staff_checks", Res.string.dashboard_staff_checks)
  map.put("dashboard_staff_expired", Res.string.dashboard_staff_expired)
  map.put("dashboard_staff_expiring", Res.string.dashboard_staff_expiring)
  map.put("dashboard_staff_role", Res.string.dashboard_staff_role)
  map.put("dashboard_switch", Res.string.dashboard_switch)
  map.put("dashboard_take_home", Res.string.dashboard_take_home)
  map.put("dashboard_team_schedule", Res.string.dashboard_team_schedule)
  map.put("dashboard_today", Res.string.dashboard_today)
  map.put("dashboard_tomorrow", Res.string.dashboard_tomorrow)
  map.put("dashboard_was_working_today", Res.string.dashboard_was_working_today)
  map.put("dashboard_weekly_skeleton", Res.string.dashboard_weekly_skeleton)
  map.put("dashboard_working_next", Res.string.dashboard_working_next)
  map.put("dashboard_workplace_fallback", Res.string.dashboard_workplace_fallback)
  map.put("dashboard_workplace_switch", Res.string.dashboard_workplace_switch)
  map.put("date", Res.string.date)
  map.put("date_day_month", Res.string.date_day_month)
  map.put("date_end_before_start", Res.string.date_end_before_start)
  map.put("date_field_placeholder", Res.string.date_field_placeholder)
  map.put("date_format_invalid", Res.string.date_format_invalid)
  map.put("date_outside_month", Res.string.date_outside_month)
  map.put("date_pick_open", Res.string.date_pick_open)
  map.put("day_closed", Res.string.day_closed)
  map.put("day_closed_holiday", Res.string.day_closed_holiday)
  map.put("day_closed_non_trading_sunday", Res.string.day_closed_non_trading_sunday)
  map.put("day_closed_sunday", Res.string.day_closed_sunday)
  map.put("day_fri_short", Res.string.day_fri_short)
  map.put("day_friday", Res.string.day_friday)
  map.put("day_friday_in_sentence", Res.string.day_friday_in_sentence)
  map.put("day_mon_short", Res.string.day_mon_short)
  map.put("day_monday", Res.string.day_monday)
  map.put("day_monday_in_sentence", Res.string.day_monday_in_sentence)
  map.put("day_no_shifts", Res.string.day_no_shifts)
  map.put("day_on_friday", Res.string.day_on_friday)
  map.put("day_on_monday", Res.string.day_on_monday)
  map.put("day_on_saturday", Res.string.day_on_saturday)
  map.put("day_on_sunday", Res.string.day_on_sunday)
  map.put("day_on_thursday", Res.string.day_on_thursday)
  map.put("day_on_tuesday", Res.string.day_on_tuesday)
  map.put("day_on_wednesday", Res.string.day_on_wednesday)
  map.put("day_sat_short", Res.string.day_sat_short)
  map.put("day_saturday", Res.string.day_saturday)
  map.put("day_saturday_in_sentence", Res.string.day_saturday_in_sentence)
  map.put("day_shifts_title", Res.string.day_shifts_title)
  map.put("day_sun_short", Res.string.day_sun_short)
  map.put("day_sunday", Res.string.day_sunday)
  map.put("day_sunday_in_sentence", Res.string.day_sunday_in_sentence)
  map.put("day_thu_short", Res.string.day_thu_short)
  map.put("day_thursday", Res.string.day_thursday)
  map.put("day_thursday_in_sentence", Res.string.day_thursday_in_sentence)
  map.put("day_tue_short", Res.string.day_tue_short)
  map.put("day_tuesday", Res.string.day_tuesday)
  map.put("day_tuesday_in_sentence", Res.string.day_tuesday_in_sentence)
  map.put("day_wed_short", Res.string.day_wed_short)
}
